import { Divider, DividerProps } from '@chakra-ui/react';
import { FC } from 'react';

export const SidebarDivider: FC<DividerProps> = (props) => {
  return <Divider my='0 !important' borderColor='border' {...props} />;
};
